import 'devextreme/dist/css/dx.light.css';
import { useEffect, useContext, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import DataGrid, { Column, Grouping, GroupPanel, SearchPanel, Summary, GroupItem, Selection } from 'devextreme-react/data-grid';
import { Spin, Row, Col, Card } from 'antd';
import { CompanySaleOdersSelector, getCompanySaleOders } from '../../store/reducers/Report/companySaleOders'
import DataDisplayWidget from '../../components/shared-components/DataDisplayWidget';
import { FileDoneOutlined, SyncOutlined, BarChartOutlined } from '@ant-design/icons';
import { Chart, Series, Label, CommonSeriesSettings, ArgumentAxis, ConstantLine } from 'devextreme-react/chart';
import PieChart, { Legend, Tooltip, Format, Connector, Export, } from 'devextreme-react/pie-chart';
import { ConstContext } from '../../store/context/constContext'
import { TimeDataSel } from '../data/data'
import { Select, DatePicker, Space } from 'antd';
import moment from 'moment';

const { Option } = Select;
const { RangePicker } = DatePicker;
const weekFormat = 'MM/DD';

const DisplayDataSet = () => {
    const CompanySaleOdersSelectors = useSelector(CompanySaleOdersSelector)
    return (
        <>
            <Row gutter={16}>
                <Col xs={24} sm={8} md={8} lg={8} xl={12} xxl={8}>
                    <DataDisplayWidget
                        icon={<SyncOutlined />}
                        value={"$"  + new Intl.NumberFormat('en-US').format(CompanySaleOdersSelectors.TotalTurnover)}
                        title="Tổng doanh thu dự kiến"
                        color="blue"
                        vertical={true}
                        avatarSize={55}
                    />
                </Col>
                <Col xs={24} sm={8} md={8} lg={8} xl={12} xxl={8}>
                    <DataDisplayWidget
                        icon={<FileDoneOutlined />}
                        value={new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOdersSelectors.TotalDelivery))}
                        title="Tổng số đơn hàng"
                        color="cyan"
                        vertical={true}
                        avatarSize={55}
                    />
                </Col>
                <Col xs={24} sm={8} md={8} lg={8} xl={12} xxl={8}>
                    <DataDisplayWidget
                        icon={<BarChartOutlined />}
                        value={new Intl.NumberFormat('en-US').format(Math.round(CompanySaleOdersSelectors.TotalQty)) + " Kg"}
                        title="Tổng sản lượng dự kiến"
                        color="gold"
                        vertical={true}
                        avatarSize={55}
                    />
                </Col>
            </Row>
            <Row gutter={16}>

            </Row>
        </>
    )
}

const customWeekStartEndFormat = (value) =>
    `${moment(value).startOf('week').format(weekFormat)} ~ ${moment(value)
        .endOf('week')
        .format(weekFormat)}`;

const CompanySaleOders = () => {
    const dispatch = useDispatch()
    const {
        isMobile,
    } = useContext(ConstContext)
    const bfFrmDate = moment().startOf('week');
    const CompanySaleOdersSelectors = useSelector(CompanySaleOdersSelector)
    const [loadData, setLoadData] = useState({ FrDate: moment(moment(bfFrmDate)).add(-7, 'days').format('yyyy/MM/DD'), ToDate: moment(moment(bfFrmDate)).add(-1, 'days').format('yyyy/MM/DD'), CardCode: "", IsCommission: 0, IsSO: 1 })
    const [selectedTimeType, setselectedTimeType] = useState('week')
    useEffect(() => {
        if (selectedTimeType === 'RangePicker') {
        }
        else if (selectedTimeType === 'week') {
            const startDate = moment(moment(bfFrmDate)).add(-7, 'days').format('yyyy/MM/DD')
            const endDate = moment(moment(bfFrmDate)).add(-1, 'days').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
        }
        else if (selectedTimeType === 'month') {
            const startDate = moment().startOf('month').format('yyyy/MM/DD')
            const endDate = moment().endOf('month').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
        }
        else if (selectedTimeType === 'year') {
            const startDate = moment().startOf('year').format('yyyy/MM/DD')
            const endDate = moment().endOf('year').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
        }
        else if (selectedTimeType === 'quarter') {
            const startDate = moment().startOf('quarter').format('yyyy/MM/DD')
            const endDate = moment().endOf('quarter').format('yyyy/MM/DD')
            setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
        }
    }, [selectedTimeType])

    useEffect(() => {
        dispatch(getCompanySaleOders(loadData))
    }, [loadData])
    const pointClickHandler = (e) => {
        toggleVisibility(e.target);
    }
    const legendClickHandler = (e) => {
        const arg = e.target;
        const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
        toggleVisibility(item);
    }
    const toggleVisibility = (item) => {
        item.isVisible() ? item.hide() : item.show();
    }
    const handleChange = (value) => {
        setselectedTimeType(value)
    };
    const dateChange = (date, datestring) => {
        if (date) {
            if (selectedTimeType === 'RangePicker') {
                setLoadData({ ...loadData, FrDate: date[0].format('yyyy/MM/DD'), ToDate: date[1].format('yyyy/MM/DD') })
            }
            else if (selectedTimeType === 'week') {
                const startDate = moment(date).startOf('week').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('week').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
            }
            else if (selectedTimeType === 'month') {
                const startDate = moment(date).startOf('month').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('month').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
            }
            else if (selectedTimeType === 'year') {
                const startDate = moment(date).startOf('year').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('year').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
            }
            else if (selectedTimeType === 'quarter') {
                const startDate = moment(date).startOf('quarter').format('yyyy/MM/DD')
                const endDate = moment(date).endOf('quarter').format('yyyy/MM/DD')
                setLoadData({ ...loadData, FrDate: startDate, ToDate: endDate })
            }
        }
    }
    const PickerWithType = ({ type, onChange }) => {
        if (type === 'date') return <DatePicker onChange={onChange} />;
        if (type === 'RangePicker') return <RangePicker format={'DD/MM/yyyy'} onChange={onChange} defaultValue={[moment(loadData.FrDate), moment(loadData.ToDate)]} />;
        if (type === 'week') return <DatePicker format={customWeekStartEndFormat} onChange={onChange} picker="week" defaultValue={moment(loadData.FrDate)} />;
        if (type === 'year') return <DatePicker onChange={onChange} picker="year" defaultValue={moment(loadData.FrDate, 'YYYY')} />;
        if (type === 'month') return <DatePicker onChange={onChange} picker="month" defaultValue={moment(loadData.FrDate, 'YYYY/MM')} />;
        return <DatePicker picker={type} onChange={onChange} defaultValue={moment(loadData.FrDate)} />;
    };
    return (
        <>
            <Space style={{marginBottom: '16px'}}>
                <Select defaultValue={selectedTimeType} style={{ width: 250 }} onChange={handleChange}>
                    {TimeDataSel.map((TimeDataSel, index) => (
                        <Option key={index} value={TimeDataSel.val}>{TimeDataSel.displayvalue}</Option>
                    ))}
                </Select>
                <PickerWithType type={selectedTimeType} onChange={dateChange} defaultValue={loadData.FrDate} />
            </Space>

            <Row gutter={16}>
                <Col xs={24} sm={24} md={24}>
                    <DisplayDataSet></DisplayDataSet>
                </Col>
            </Row>
            <Row gutter={16} style={{ justifyContent: 'center' }}>
                <Col xs={24} sm={24} md={24} lg={12} xl={9} xxl={12} >
                    <Card>
                        <Chart id={"chart"}
                            // size={{ height: 400, width: 778 }}
                            dataSource={CompanySaleOdersSelectors.SalesByEmployee}
                            rotated={false} >
                            <CommonSeriesSettings argumentField="lastName" />
                            <ArgumentAxis >
                                <Label displayMode="stagger" />
                            </ArgumentAxis>
                            <Series valueField={"GTotal"}
                                name={isMobile ? " " : "Doanh thu nhân viên"}
                                type={"bar"}
                                color={"#79cac4"} >
                                <Label displayMode="rotate" visible={true} format={CompanySaleOdersSelectors.SalesByEmployee[0]?.GTotal < 1000000000 ? "millions" :"billions"}></Label>
                            </Series>
                            <Tooltip enabled={true}
                                customizeTooltip={customizeTooltipBarChart}>
                                <Format type="###,###,###" />
                            </Tooltip>
                            <Export enabled={false} />
                        </Chart>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={9} xxl={12}>
                    <Card>
                        <PieChart id={"pie"}
                            title={"Sản lượng theo loại giấy"}
                            palette={"Carmine"}
                            // size={{ height: 400, width: 778 }}
                            dataSource={CompanySaleOdersSelectors.QtyByPro2}
                            onPointClick={pointClickHandler}
                            onLegendClick={legendClickHandler}>
                            <Series argumentField={"U_Pro_2"}>
                                <Label visible={true}
                                    format="fixedPoint"
                                    customizeText={customizeLabel}>
                                    <Connector visible={true} />
                                </Label>
                            </Series>
                            <Export enabled={false} />
                            <Legend
                                verticalAlignment="bottom"
                                horizontalAlignment="center"
                                itemTextPosition="right"
                                rowCount={2}
                            />
                            <Tooltip enabled={true}
                                customizeTooltip={customizeTooltip}>
                                <Format type="###,###,###" />
                            </Tooltip>
                        </PieChart>

                    </Card>
                </Col>
            </Row>

            <Spin tip="Loading..." spinning={CompanySaleOdersSelectors.Loading}>
                <div style={{backgroundColor: 'white', padding: '10px'}}>
                    <DataGrid dataSource={CompanySaleOdersSelectors.allPageLoad}
                        allowColumnReordering={true}
                        rowAlternationEnabled={true}
                        showBorders={true}
                        columnAutoWidth={true}>
                        <Selection mode="single" />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <SearchPanel visible={true} highlightCaseSensitive={true} width={200} />
                        <Column dataField="Dscription" caption={"Tên hàng"} dataType="string" />
                        <Column dataField="U_Pro_2" caption={"Loại giấy"} dataType="number" groupIndex={0} />
                        <Column dataField="U_Pro_5" caption={"Định lượng"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="U_Pro_6" caption={"Chiều rộng"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="U_Length" caption={"Chiều dài"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="InvQty" caption={"SL (KG)"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="Commission" caption={"Giá chưa HH"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="PriceAfVAT" caption={"Giá sau VAT"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="CL_Price" caption={"CL (Đ/Kg)"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="GTotal" caption={"Doanh số sau VAT"} dataType="number" format={"#,###,###.##"} />
                        <Column dataField="Comments" caption={"Ghi chú"} dataType="string" />
                        <Column dataField="U_NoteForAcc" caption={"Ghi chú KT"} dataType="string" />
                        <Column dataField="U_QuantityReam" caption={"SL Ream/cuộn"} dataType="number" format={"#,###,###.##"} />
                        <Summary>
                            <GroupItem
                                column="GTotal"
                                summaryType="sum"
                                valueFormat="currency"
                                showInGroupFooter={false}
                                alignByColumn={true} />
                            <GroupItem
                                column="InvQty"
                                summaryType="sum"
                                valueFormat="###,###,###.###"
                                showInGroupFooter={false}
                                alignByColumn={true} />
                        </Summary>
                    </DataGrid>
                </div>
                
            </Spin>
        </>
    );
    function customizeTooltip(pointInfo) {
        return {
            text: `${pointInfo.argumentText} : ${pointInfo.valueText} - ${(pointInfo.percent * 100).toFixed(2)}%`,
        };
    }

    function customizeTooltipBarChart(pointInfo) {
        return {
            text: `${pointInfo.point.data.SlpName} <br/> <br/> ${pointInfo.valueText}`,
        };
    }
    function customizeLabel(pointInfo) {
        return `${pointInfo.argumentText}: ${pointInfo.valueText}`;
    }
}

export default CompanySaleOders;